<template>
  <div class="box">
    <div class="getCode">
      <van-button type="info" @click="getCode">获取验证码</van-button>
    </div>
    <van-cell-group>
      <van-field v-model="form1.check_code" label="验证码" placeholder="请输入验证码" />
    </van-cell-group>
    <div class="sureBtn">
      <van-button type="info" @click="submit">确定</van-button>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Notify } from "vant";
export default {
  data() {
    return {
      //   form: {
      //     merchant_id: "",
      //   },
      form1: {
        merchant_id: "",
        check_code: "",
      },
    };
  },
  mounted() {
    // this.form.merchant_id = this.$route.query.id * 1;
    this.form1.merchant_id = this.$route.query.id * 1;
    console.log(this.merchant_id);
  },
  methods: {
    getCode() {
      this.$http
        .post("/wechat/api.merchant/electronicContract", {
          merchant_id: this.form1.merchant_id,
        })
        .then(function (response) {
          Toast.clear();
          if (response && response.data.code == 200) {
            Dialog.confirm({
              title: "温馨提示",
              message: response.data.msg,
            })
              .then(() => {
                // this.$router.go(-1);
              })
              .catch(() => {
                // on cancel
              });
          } else {
            Dialog.confirm({
              title: "温馨提示",
              message: response.data.msg,
            })
              .then(() => {})
              .catch(() => {});
          }
        });
    },
    submit() {
      if (!this.form1.check_code) {
        Toast.fail("请输入验证码");
        return;
      }
      this.$http
        .post("/wechat/api.merchant/signContract", this.form1)
        .then(function (response) {
          Toast.clear();
          if (response && response.data.code == 200) {
            Dialog.confirm({
              title: "温馨提示",
              message: response.data.msg,
            })
              .then(() => {
                this.$router.go(-1);
                // VueCookie.remove("payCode");
                // //跳转首页

                // window.location.href = "/SalesmanHome";
              })
              .catch(() => {
                // on cancel
              });
          } else {
            Dialog.confirm({
              title: "温馨提示",
              message: response.data.msg,
            })
              .then(() => {})
              .catch(() => {});
          }
          // console.log('response', response); this.$route.query.pay_code
        });
    },
  },
};
</script>
<style scoped>
.box {
  margin: 30px;
}
.getCode {
  margin-bottom: 25px;
}
.sureBtn {
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;
}
</style>